import { createAPI } from '@common'

export default {
  getWXAuthorCallback: config => createAPI('customEncryptApiName-1/0w20XYBvuipsDbmmcbdl', 'get', config)
}
